import { RspndrNotify } from '@hakimo-ui/hakimo/types';
import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { useRef } from 'react';
import { useMutation, useQueryClient } from 'react-query';

export function useRspndrNotification(
  onSuccess?: (rspndr: RspndrNotify) => void,
  onError?: (err: Error) => void,
  getApiToken?: () => Promise<string>,
  tenantId?: string,
  rspndrNotifyUrl?: string
) {
  const url = rspndrNotifyUrl || '';
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();
  const getApiTokenRef = useRef(getApiToken);
  getApiTokenRef.current = getApiToken;

  return useMutation<RspndrNotify, Error, RspndrNotify | null>(
    async (data) => {
      const token = getApiTokenRef.current
        ? await getApiTokenRef.current()
        : '';
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-RSPNDR-TENANT-ID': tenantId || '',
          'X-RSPNDR-API-TOKEN': token,
        },
        body: JSON.stringify(data),
      });
      return httpClient<RspndrNotify>(request, { noAuth: true });
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['rspndr']);
        if (onSuccess) onSuccess(data);
      },
      onError,
    }
  );
}

export default useRspndrNotification;
